/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkingTimeCostBreakdown } from './WorkingTimeCostBreakdown';
import {
    WorkingTimeCostBreakdownFromJSON,
    WorkingTimeCostBreakdownFromJSONTyped,
    WorkingTimeCostBreakdownToJSON,
    WorkingTimeCostBreakdownToJSONTyped,
} from './WorkingTimeCostBreakdown';

/**
 * 
 * @export
 * @interface WorkingTimeCost
 */
export interface WorkingTimeCost {
    /**
     * 
     * @type {number}
     * @memberof WorkingTimeCost
     */
    employeeId: number;
    /**
     * 
     * @type {number}
     * @memberof WorkingTimeCost
     */
    jobRoleId: number;
    /**
     * 
     * @type {number}
     * @memberof WorkingTimeCost
     */
    cost: number;
    /**
     * 
     * @type {Array<WorkingTimeCostBreakdown>}
     * @memberof WorkingTimeCost
     */
    workingPeriodRates: Array<WorkingTimeCostBreakdown>;
}

/**
 * Check if a given object implements the WorkingTimeCost interface.
 */
export function instanceOfWorkingTimeCost(value: object): value is WorkingTimeCost {
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('jobRoleId' in value) || value['jobRoleId'] === undefined) return false;
    if (!('cost' in value) || value['cost'] === undefined) return false;
    if (!('workingPeriodRates' in value) || value['workingPeriodRates'] === undefined) return false;
    return true;
}

export function WorkingTimeCostFromJSON(json: any): WorkingTimeCost {
    return WorkingTimeCostFromJSONTyped(json, false);
}

export function WorkingTimeCostFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkingTimeCost {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'],
        'jobRoleId': json['jobRoleId'],
        'cost': json['cost'],
        'workingPeriodRates': ((json['workingPeriodRates'] as Array<any>).map(WorkingTimeCostBreakdownFromJSON)),
    };
}

  export function WorkingTimeCostToJSON(json: any): WorkingTimeCost {
      return WorkingTimeCostToJSONTyped(json, false);
  }

  export function WorkingTimeCostToJSONTyped(value?: WorkingTimeCost | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
        'jobRoleId': value['jobRoleId'],
        'cost': value['cost'],
        'workingPeriodRates': ((value['workingPeriodRates'] as Array<any>).map(WorkingTimeCostBreakdownToJSON)),
    };
}

